import { render, staticRenderFns } from "./OsCreateCustomer.vue?vue&type=template&id=d023bfa8&scoped=true"
import script from "./OsCreateCustomer.vue?vue&type=script&lang=ts"
export * from "./OsCreateCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023bfa8",
  null
  
)

export default component.exports